import {
  CStackSpace,
  TabAlign,
  TabDivider,
  TabSize,
  type TabGroupFragment,
} from '@seek/cmsu-cms-connect';
import {
  Stack,
  Tab,
  TabPanel,
  TabPanels,
  Tabs,
  TabsProvider,
} from 'braid-design-system';

import { BlockRenderer, type BlockItemRenderers } from '../../renderer';
import type { AdditionalData } from '../../renderer/AdditionalData';

type Props = Omit<TabGroupFragment, 'id' | 'tabs'> & {
  renderers: BlockItemRenderers;
  additionalData: AdditionalData;
};

export const TabGroup = ({
  tabContent,
  renderers,
  additionalData,
  tabAlign,
  tabDividerWidth,
  tabGutter,
  tabSize,
}: Props) => {
  const tabsLabels = tabContent.map((tab) => ({
    id: tab.id,
    label: tab.label,
  }));
  // cant do default value from props because from hygraph it can be null
  const finalTabAlign = tabAlign ?? TabAlign.Left;
  const finalTabDividerWidth = tabDividerWidth ?? TabDivider.Minimal;
  const finalTabGutter = tabGutter ?? CStackSpace.Gutter;
  const finalTabSize = tabSize ?? TabSize.Standard;
  const tabsIds = tabContent.map((tab) => tab.id);
  return (
    <TabsProvider id={`TabsProvider-${tabsIds.join('-')}`}>
      <Stack space="medium">
        <Tabs
          label={`Tabs-${tabsIds.join('-')}`}
          align={finalTabAlign}
          divider={finalTabDividerWidth}
          gutter={finalTabGutter}
          size={finalTabSize}
        >
          {tabsLabels.map((item) => (
            <Tab key={item.id}>{item.label}</Tab>
          ))}
        </Tabs>
        <TabPanels>
          {tabContent.map((block, _index) => (
            <TabPanel key={block.id}>
              <BlockRenderer
                block={block}
                renderers={renderers}
                additionalData={additionalData}
              />
            </TabPanel>
          ))}
        </TabPanels>
      </Stack>
    </TabsProvider>
  );
};
